<template>
  <div class="container mt-4">
    <h3 class="text-center text-uppercase fw-bold">Boletos</h3>
    <p class="text-end ">
      <strong>Pasta:</strong> {{ pasta }} |
      <strong>Referência do Imóvel:</strong> {{ referencia }}
    </p>

    <!-- Ícones de navegação -->
    <div class="row mb-4 text-center">
      <div class="col" v-for="icon in icones" :key="icon.label">
        <router-link :to="`${icon.rota}/${pasta}`">
          <img :src="icon.img" class="icon-menu" />
          <p class="black">{{ icon.label }}</p>
        </router-link>
      </div>
    </div>

    <h5 class="fw-bold text-center mt-3">PARÂMETROS PARA EMISSÃO</h5>

    <!-- Campos principais -->
    <div class="row g-3 mt-3">
      <div class="col-md-2">
        <label>Valor Aluguel:</label>
        <input v-model="valorAluguel" class="form-control" readonly />
      </div>
      <div class="col-md-2">
        <label>Condomínio:</label>
        <input v-model="condominio" class="form-control" @input="formatarMoeda('condominio')" />
      </div>
      <div class="col-md-2">
        <label>IPTU:</label>
        <input v-model="iptu" class="form-control" readonly />
      </div>
      <div class="col-md-2">
        <label>Seguro fiança:</label>
        <input v-model="fianca" class="form-control" readonly />
      </div>
      <div class="col-md-2">
        <label>Seguro incêndio:</label>
        <input v-model="seguro" class="form-control" @input="formatarMoeda('seguro')" />
      </div>
      <div class="col-md-2">
        <label>Taxa Boleto:</label>
        <input v-model="taxaBoleto" class="form-control" readonly />
      </div>
       <div class="w-100"></div>
      <div class="col-md-2 mt-3">
        <label>Outros adicionais:</label>
        <button class="btn btn-outline-primary w-100" @click="adicionarCampo('outros')">+ Adicionar</button>
      </div>
    </div>

    <!-- Campos dinâmicos Outros -->
    <div v-for="(item, i) in outros" :key="'outro'+i" class="row mt-2">
      <div class="col-md-6">
        <input v-model="item.descricao" class="form-control" placeholder="Descrição do valor" />
      </div>
      <div class="col-md-4">
        <input v-model="item.valor" class="form-control" @input="formatarMoedaCampo(item, 'valor')" />
      </div>
      <div class="col-md-2">
        <button class="btn btn-danger w-100" @click="removerCampo('outros', i)">Remover</button>
      </div>
    </div>

    <!-- Campo de descontos -->
    <div class="row mt-3">
      <div class="col-md-2">
        <label>Descontos:</label>
        <button class="btn btn-outline-primary w-100" @click="adicionarCampo('descontos')">+ Adicionar</button>
      </div>
    </div>

    <!-- Campos dinâmicos Descontos -->
    <div v-for="(item, i) in descontos" :key="'desconto'+i" class="row mt-2">
      <div class="col-md-6">
        <input v-model="item.descricao" class="form-control" placeholder="Descrição do desconto" />
      </div>
      <div class="col-md-4">
        <input v-model="item.valor" class="form-control" @input="formatarMoedaCampo(item, 'valor')" />
      </div>
      <div class="col-md-2">
        <button class="btn btn-danger w-100" @click="removerCampo('descontos', i)">Remover</button>
      </div>
    </div>

    <!-- Informações complementares -->
    <div class="row mt-4">
      <div class="col-md-6">
        <label>Informações complementares:</label>
        <textarea v-model="info" class="form-control"></textarea>
      </div>
      <div class="col-md-3">
        <label>Vencimento:</label>
        <input type="date" v-model="vencimento" class="form-control" />
      </div>
      <div class="col-md-3">
        <label>Valor total:</label>
        <input :value="valorTotalFormatado" class="form-control" readonly />
      </div>
    </div>

    <!-- Botão gerar -->
    <div class="text-center mt-4">
      <button class="btn btn-success btn-lg" @click="gerarBoleto">GERAR BOLETO</button>
    </div>

    <!-- Boletos gerados -->
    <div class="mt-5">
      <h5 class="fw-bold">Boletos gerados</h5>
      <table class="table table-striped">
        <thead>
          <tr>
            <th>Vencimento</th>
            <th>Valor total</th>
            <th>Data emissão</th>
            <th>Pago?</th>
            <th>Boleto</th>
            <th>Ações</th>
          </tr>
        </thead>
<tbody>
  <tr v-for="b in boletos" :key="b.id">
    <td>{{ formatarDataBR(b.vencimento) }}</td>
    <td>{{ formatarValorBR(b.valor_total) }}</td>
    <td>{{ formatarDataBR(b.data_emissao) }}</td>
    <td> <span style="color:#FFF;"
            :class="{
              'badge bg-success': b.pago == 1,
              'badge bg-danger': b.pago == 0
            }"
          >
            {{ b.pago == 1 ? 'Sim' : 'Não' }}
          </span></td>
           <td>
          <a
            v-if="b.arquivo_pdf"
            :href="`${baseUrl}uploads/boletos/${b.arquivo_pdf}`"
            target="_blank"
            class="btn btn-outline-secondary btn-sm"
          >
            Ver PDF
          </a>
        </td>
    <td>
         <router-link
            class="btn btn-primary btn-sm me-1"
            :to="`/edicaoBoleto/${pasta}/${b.id}`"
          >
            Visualizar
          </router-link>
      <button class="btn btn-danger btn-sm" @click="excluir(b.id)">Excluir</button>
    </td>
  </tr>
</tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      pasta: "",
      referencia: "",
      valorAluguel: "R$ 0,00",
      iptu: "R$ 0,00",
      fianca: "R$ 0,00",
      taxaBoleto: "R$ 0,00",
      condominio: "",
      seguro: "",
      vencimento: "",
      info: "",
      outros: [],
      descontos: [],
      boletos: [],
      baseUrl: "https://www2.royaljardim.com.br/sistema/",
      icones: [
        { label: "FICHA", img: "/img/ficha.png", rota: "/locacao" },
        { label: "BOLETOS", img: "/img/boletos.png", rota: "/boletos" },
        { label: "REPASSES", img: "/img/repasses.png", rota: "/repasses" },
        { label: "IPTU", img: "/img/iptu.png", rota: "/iptuClientes" },
             { label: "SEGURO", img: "/img/seguro.png", rota: "/seguroFianca" },
        { label: "RELATÓRIOS", img: "/img/relatorios.png", rota: "/relatorios" },
      ],
    };
  },
  computed: {
    valorTotal() {
      const fixos =
        this.parseMoeda(this.valorAluguel) +
        this.parseMoeda(this.iptu) +
        this.parseMoeda(this.fianca) +
        this.parseMoeda(this.taxaBoleto) +
        this.parseMoeda(this.condominio) +
        this.parseMoeda(this.seguro);
      const somaOutros = this.outros.reduce((s, o) => s + this.parseMoeda(o.valor), 0);
      const somaDescontos = this.descontos.reduce((s, d) => s + this.parseMoeda(d.valor), 0);
      return fixos + somaOutros - somaDescontos;
    },
    valorTotalFormatado() {
      return this.valorTotal.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
    },
  },
  mounted() {
    this.pasta = this.$route.params.id || "";
    this.carregarDados();
    this.listarBoletos();
  },
  methods: {
    carregarDados() {
    axios.post(this.baseUrl + "boletos", new URLSearchParams({
      acao: "dados",
      pasta: this.pasta
    }))
    .then(res => {
      const d = res.data;
      if (!d.erro) {
        this.valorAluguel = d.valor_aluguel;
        this.iptu = d.iptu;
        this.fianca = d.fianca;
        this.taxaBoleto = d.taxa_boleto;
        this.referencia = d.referencia;

        // Calcula a data de vencimento automaticamente
        this.vencimento = this.calcularVencimentoAutomatico(d.vencimento);
      }
    })
    .catch(err => console.error(err));
  },
    // Calcula data de vencimento automática com base em LOC_VENCIMENTO
  calcularVencimentoAutomatico(loc_vencimento) {
    try {
      const diaVencimento = parseInt(loc_vencimento, 10);
      const hoje = new Date();

      let ano = hoje.getFullYear();
      let mes = hoje.getMonth(); // 0 = janeiro
      const diaAtual = hoje.getDate();

      if (diaAtual > diaVencimento) {
        mes += 1; // vai para o próximo mês
        if (mes > 11) {
          mes = 0;
          ano += 1;
        }
      }

      // Cria data final
      const dataFinal = new Date(ano, mes, diaVencimento);

      // Converte para yyyy-MM-dd (para o campo type="date")
      const yyyy = dataFinal.getFullYear();
      const mm = String(dataFinal.getMonth() + 1).padStart(2, '0');
      const dd = String(dataFinal.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    } catch (e) {
      console.error("Erro ao calcular vencimento:", e);
      return "";
    }
  },
    listarBoletos() {
      axios.post(this.baseUrl + "boletos", new URLSearchParams({
        acao: "listar",
        pasta: this.pasta
      }))
      .then(res => {
        this.boletos = res.data;
      })
      .catch(err => console.error(err));
    },
   gerarBoleto() {
  const form = new FormData();
  form.append("acao", "salvar");
  form.append("pasta", this.pasta);
  form.append("vencimento", this.vencimento);
  form.append("valor_total", this.valorTotal);
  form.append("info", this.info);

  //  Inclui também os valores fixos e automáticos
  form.append("valor_aluguel", this.parseMoeda(this.valorAluguel));
  form.append("valor_iptu", this.parseMoeda(this.iptu));
  form.append("valor_fianca", this.parseMoeda(this.fianca)); 
  form.append("valor_taxa_boleto", this.parseMoeda(this.taxaBoleto));
  form.append("valor_condominio", this.parseMoeda(this.condominio));
  form.append("valor_seguro", this.parseMoeda(this.seguro));

  // Inclui os arrays dinâmicos
  form.append("outros", JSON.stringify(this.outros));
  form.append("descontos", JSON.stringify(this.descontos));

  axios.post(this.baseUrl + "boletos", form)
  .then(() => this.listarBoletos())
  .catch(err => console.error(err));
},
    excluir(id) {
      if (confirm("Deseja excluir este boleto?")) {
        axios.post(this.baseUrl + "boletos", new URLSearchParams({
          acao: "excluir",
          id: id
        }))
        .then(() => this.listarBoletos())
        .catch(err => console.error(err));
      }
    },
    adicionarCampo(tipo) {
      this[tipo].push({ descricao: "", valor: "" });
    },
    removerCampo(tipo, i) {
      this[tipo].splice(i, 1);
    },
    parseMoeda(v) {
      return parseFloat(v.replace(/[R$\s.]/g, "").replace(",", ".")) || 0;
    },
    formatarMoeda(campo) {
      this[campo] = this.formatarValor(this[campo]);
    },
    formatarMoedaCampo(obj, prop) {
      obj[prop] = this.formatarValor(obj[prop]);
    },
    formatarValor(v) {
      v = v.replace(/[^\d]/g, "");
      const num = parseFloat(v) / 100;
      return num.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
    },
    formatarValorBR(v) {
      return parseFloat(v).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });
    },
  formatarDataBR(data) {
  if (!data) return "";
  // ⚠ Corrige o bug de fuso horário (tratando a string como data local)
  const partes = data.split(/[-T\s:]/);
  const ano = parseInt(partes[0]);
  const mes = parseInt(partes[1]) - 1;
  const dia = parseInt(partes[2]);
  const d = new Date(ano, mes, dia);

  const dd = String(d.getDate()).padStart(2, "0");
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const yyyy = d.getFullYear();
  return `${dd}/${mm}/${yyyy}`;
},
  },
};
</script>

<style scoped>
.icon-menu {
  width: 60px;
  height: 60px;
  cursor: pointer;
}
p {
  margin-top: 5px;
  font-weight: bold;
}
.black{color:#000;}
label,h5,h4,h1,h2,h3{color:#4C1C17;font-weight:bold;}
</style>